<div class="d-flex flex-column col-12 form-amount-container gap-3" *ngIf="campaign as camp">
  <div class="campaign-intro" *ngIf="section === 'full' || section === 'intro'">
    <div class="campaign-intro__header">
      <div class="campaign-intro__identity">
        <span class="campaign-intro__avatar" aria-hidden="true">
          <img class="campaign-intro__logo" src="assets/Image/Logo/logo.png" alt="{{ 'CAMPAIGN.BrandAlt' | translate }}" />
        </span>

        <div class="campaign-intro__title-group">
          <h4 class="text-title-campaign text-start">{{ name }}</h4>

          <div class="campaign-description-wrapper" *ngIf="introDescription">
            <div class="campaign-description-stack">
              <p class="campaign-description-text">{{ introDescription }}</p>

              <button type="button" class="campaign-intro__read-more" (click)="openReadMore()">
                {{ 'CAMPAIGN.ReadMoreProject' | translate }}
                <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="campaign-intro__share-wrap">
        <button
          type="button"
          class="campaign-intro__share"
          (click)="toggleShareMenu($event)"
          [attr.aria-expanded]="isShareMenuOpen"
        >
          <i class="fa-solid fa-share-nodes" aria-hidden="true"></i>
          {{ 'CAMPAIGN.Share' | translate }}
        </button>

        <div class="campaign-share-menu" *ngIf="isShareMenuOpen">
          <p class="campaign-share-menu__title">{{ 'CAMPAIGN.ShareThisCampaign' | translate }}</p>
          <button
            type="button"
            class="campaign-share-item campaign-share-item--instagram"
            (click)="shareOn('instagram')"
            [disabled]="preparingChannel !== null"
          >
            <span class="campaign-share-item__icon campaign-share-item__icon--instagram" aria-hidden="true">
              <i class="fa-brands fa-instagram"></i>
            </span>

            <span class="campaign-share-item__label" *ngIf="preparingChannel !== 'instagram'">
              {{ 'CAMPAIGN.Instagram' | translate }}
            </span>

            <span class="campaign-share-item__loading" *ngIf="preparingChannel === 'instagram'" aria-live="polite">
              <span class="campaign-share-item__spinner" aria-hidden="true"></span>
              {{ 'CAMPAIGN.PreparingImage' | translate }}
            </span>
          </button>
          <button type="button" class="campaign-share-item" (click)="shareOn('facebook')" [disabled]="preparingChannel !== null">
            <span class="campaign-share-item__icon campaign-share-item__icon--facebook" aria-hidden="true">
              <i class="fa-brands fa-facebook-f"></i>
            </span>
            <span class="campaign-share-item__label" *ngIf="preparingChannel !== 'facebook'">{{ 'CAMPAIGN.Facebook' | translate }}</span>
            <span class="campaign-share-item__loading" *ngIf="preparingChannel === 'facebook'" aria-live="polite">
              <span class="campaign-share-item__spinner" aria-hidden="true"></span>
              {{ 'CAMPAIGN.PreparingImage' | translate }}
            </span>
          </button>
          <button type="button" class="campaign-share-item" (click)="shareOn('whatsapp')" [disabled]="preparingChannel !== null">
            <span class="campaign-share-item__icon campaign-share-item__icon--whatsapp" aria-hidden="true">
              <i class="fa-brands fa-whatsapp"></i>
            </span>
            <span class="campaign-share-item__label" *ngIf="preparingChannel !== 'whatsapp'">{{ 'CAMPAIGN.WhatsApp' | translate }}</span>
            <span class="campaign-share-item__loading" *ngIf="preparingChannel === 'whatsapp'" aria-live="polite">
              <span class="campaign-share-item__spinner" aria-hidden="true"></span>
              {{ 'CAMPAIGN.PreparingImage' | translate }}
            </span>
          </button>
          <button type="button" class="campaign-share-item" (click)="copyLink()">
            <span class="campaign-share-item__icon campaign-share-item__icon--copy" aria-hidden="true">
              <i class="fa-solid fa-link"></i>
            </span>
            {{ copiedLink ? ('CAMPAIGN.LinkCopied' | translate) : ('CAMPAIGN.CopyLink' | translate) }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="progress-section" *ngIf="section === 'full' || section === 'progress'">
    <p class="progress-section__kicker">{{ 'CAMPAIGN.ProgressLabel' | translate }}</p>

    <div class="luxbar__header">
      <span class="luxbar__amount">
        ${{ camp.currentAmount | number }}
        <span class="sep">{{ 'CAMPAIGN.Of' | translate }}</span>
        ${{ camp.targetAmount | number }}
      </span>

      <span class="luxbar__percent">{{ progressPct | number:'1.2-2' }}%</span>
    </div>

    <div class="luxbar" role="progressbar" [attr.aria-valuenow]="progressPct" aria-valuemin="0" aria-valuemax="100">
      <div
        class="luxbar__fill"
        [style.width.%]="progressPctAnimated"
        [class.luxbar__fill--visible]="progressPctAnimated > 0"
        [class.luxbar__fill--complete]="progressPctAnimated >= 100"
      ></div>
    </div>
  </div>
</div>

<don-campaign-detail-modal
  [campaign]="campaign"
  [isOpen]="isReadMoreOpen"
  (close)="closeReadMore()"
></don-campaign-detail-modal>

<div class="story-export-stage" aria-hidden="true" *ngIf="section === 'full' || section === 'intro'">
  <don-campaign-story-card [campaign]="campaign" [donorsCount]="donorsCount"></don-campaign-story-card>
</div>
